import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { logo } from 'src/assets/logo';
// import * as firebase from "firebase/app";
// const config = {  apiKey: "AIzaSyD8d_ce6KVZ4kjml11YLfkmwVv9FCw0jwY",
//   authDomain: "videochat-264e7.firebaseapp.com",
//   databaseURL: "https://videochat-264e7.firebaseio.com",
//   projectId: "videochat-264e7",
//   storageBucket: "videochat-264e7.appspot.com",
//   messagingSenderId: "1000856415333",
//   appId: "1:1000856415333:web:fca4439362d8148c"};

// export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  logo;
  constructor(private ls: LocalStorageService, private router:Router) { }

  ngOnInit() {
    this.logo = logo;
    this.ls.set('username','');
  }

  submit() {
    const data = (<HTMLInputElement>document.getElementById('username')).value;
    if (data) {
      this.ls.set('username',data);
      this.router.navigate(['/chat']);
    }
  }

  signUpRegular(e) {
    // const email = e.value.email;
    // const password = e.value.password;

    // console.log(firebase);

    // return firebase.auth().createUserWithEmailAndPassword(email, password);
    // return firebase.auth.signInWithEmailAndPassword(email, password);
  }

  // signInRegular(e) {
  //   const email = e.value.email;
  //   const password = e.value.password;

  //   console.log(firebase);
  //   this.signInUser(email, password)
  //     .then((user) => {
  //       console.log(user.user)
  //     })
      
  // }

  // signInUser(email: string, password: string) {
  //   return firebase.auth().signInWithEmailAndPassword(email, password);
  // }

}